<template>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M10 0C4.5 0 0 4.5 0 10C0 15.5 4.5 20 10 20C15.5 20 20 15.5 20 10C20 4.5 15.5 0 10 0ZM10 18C5.6 18 2 14.4 2 10C2 5.6 5.6 2 10 2C14.4 2 18 5.6 18 10C18 14.4 14.4 18 10 18ZM8 12.2L13.9 6.3C14.3 5.9 14.9 5.9 15.3 6.3C15.7 6.7 15.7 7.3 15.3 7.7L8.7 14.3C8.3 14.7 7.7 14.7 7.3 14.3L4.7 11.7C4.3 11.3 4.3 10.7 4.7 10.3C4.9 10.1 5.2 10 5.4 10C5.6 10 5.9 10.1 6.1 10.3L8 12.2Z" fill="white"></path>
</template>

<script>
    export default {
        name: 'icon-success'
    }
</script>